// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__Xz0Kb","logoName":"styles_logoName__vL2Nr","small":"styles_small__zefB7"};